import { Button, Toast, ToastTitle, ToastTrigger } from '@fluentui/react-components';
import { DismissRegular } from '@fluentui/react-icons';
import { observer } from 'mobx-react-lite';
import React from 'react';
import './CustomToast.scss';

interface CustomToastProps {
  title: string | React.JSX.Element;
}

const CustomToastImpl: React.FC<CustomToastProps> = props => {
  const {
    title,
  } = props;

  return (
    <Toast>
      <ToastTitle
        action={
          <ToastTrigger>
            <Button
              appearance='transparent'
              aria-label='Dismiss'
              icon={<DismissRegular />}
            />
          </ToastTrigger>
        }
      >
        {title}
      </ToastTitle>
    </Toast>
  );
}

export const CustomToast = observer(CustomToastImpl);
